export function processNeedRedirectWindowToFallback(
  opener: Window,
  url: string,
  fallbackUrl: string
) {
  const intervalId = setInterval(() => {
    try {
      if (opener.closed) {
        clearInterval(intervalId);
        return;
      }

      if (opener.location.href !== url) {
        opener.location.href = fallbackUrl;
        clearInterval(intervalId);
      }
    } catch (error) {
      console.error(
        'Redirect detected, cannot access cross-origin URL:',
        error
      );
      opener.location.href = fallbackUrl;
      clearInterval(intervalId);
    }
  }, 300);
}
